import React from 'react';
export function Summary({
  cart,
  pricingData,
  priceType,
  total,
  onClearCart
}) {
  return <div className="mb-8 border-t border-b py-6" data-id="element-205">
      <div className="flex justify-between items-center mb-4" data-id="element-206">
        <h2 className="text-2xl font-bold text-blue-900" data-id="element-207">Quote Summary</h2>
        <button className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700" onClick={onClearCart} data-id="element-208">
          START OVER
        </button>
      </div>
      <div className="overflow-x-auto" data-id="element-209">
        <table className="min-w-full bg-white border" data-id="element-210">
          <thead data-id="element-211">
            <tr className="bg-gray-100" data-id="element-212">
              <th className="py-2 px-4 border text-left" data-id="element-213">Item</th>
              <th className="py-2 px-4 border text-right" data-id="element-214">Price</th>
              <th className="py-2 px-4 border text-center" data-id="element-215">Quantity</th>
              <th className="py-2 px-4 border text-right" data-id="element-216">Subtotal</th>
            </tr>
          </thead>
          <tbody data-id="element-217">
            {Object.entries(cart).map(([itemId, quantity]) => {
            const item = pricingData.find(p => p.id === itemId);
            if (!item) return null;
            const price = item[priceType];
            const subtotal = price * quantity;
            return <tr key={itemId} data-id="element-218">
                  <td className="py-2 px-4 border" data-id="element-219">
                    <div className="font-medium" data-id="element-220">{item.name}</div>
                    {item.description && <div className="text-sm text-gray-600" data-id="element-221">
                        {item.description}
                      </div>}
                  </td>
                  <td className="py-2 px-4 border text-right" data-id="element-222">
                    ${price.toFixed(2)}
                  </td>
                  <td className="py-2 px-4 border text-center" data-id="element-223">{quantity}</td>
                  <td className="py-2 px-4 border text-right" data-id="element-224">
                    ${subtotal.toFixed(2)}
                  </td>
                </tr>;
          })}
          </tbody>
          <tfoot data-id="element-225">
            <tr className="bg-gray-100" data-id="element-226">
              <td colSpan={3} className="py-2 px-4 border text-right font-bold" data-id="element-227">
                Total:
              </td>
              <td className="py-2 px-4 border text-right font-bold" data-id="element-228">
                ${total}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>;
}